import { render, staticRenderFns } from "./HomeGoogle.vue?vue&type=template&id=2d79d7c1&"
import script from "./HomeGoogle.vue?vue&type=script&lang=js&"
export * from "./HomeGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports